import api from "./axiosInstance";

const vendorApi = {
  create: async (vendorData) => {
    // The axios instance automatically handles JSON stringification and headers.
    // The response data is available in `response.data`.
    const response = await api.post("vendor/create", vendorData);
    return response.data;
  },

  update: async (id, vendorData) => {
    const response = await api.put(`vendor/update/${id}`, vendorData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`vendor/delete/${id}`);
    return response.data;
  },

  getAll: async () => {
    const response = await api.get("vendor/getAll");
    return response.data;
  },

  getByName: async (name) => {
    const response = await api.get("vendor/getByName", {
      params: { name },
    });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`vendor/getById/${id}`);
    return response.data;
  },
};

export default vendorApi;